import { Reveal } from "./Reveal";
import { MANIFESTO, PROFILE } from "../data/work";

export default function Manifesto() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="px-5 md:px-12 py-24 md:py-36 max-w-[1600px] mx-auto"
    >
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-vermilion mb-4">
          (About) The way I work
        </p>
      </Reveal>

      {/* MICA ad — sits directly above the how-I-work pointers */}
      <Reveal className="mt-10 md:mt-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 items-start">
          <div className="md:col-span-4 md:sticky md:top-28">
            <h3 className="font-serif text-3xl md:text-4xl text-ink leading-tight mb-5">
              Why in the world do I even exist?
            </h3>
            <p className="text-base md:text-lg text-muted2 leading-relaxed">
              An ad I wrote about myself at MICA. Still the truest brief I have ever
              answered, and the fastest way to know how I think.
            </p>
          </div>
          <div className="md:col-span-8">
            <img
              data-testid="about-ad-image"
              src="/ad-mica.jpg"
              alt="Why in the world do I even exist? An ad Srishti wrote about herself at MICA."
              loading="lazy"
              className="w-full bg-white border border-line shadow-[0_20px_60px_-30px_rgba(0,0,0,0.4)]"
            />
          </div>
        </div>
      </Reveal>

      <div className="mt-16 md:mt-24 border-t border-line">
        {MANIFESTO.map((c, i) => (
          <Reveal
            key={c.no}
            delay={i * 0.05}
            className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-b border-line group"
          >
            <div className="md:col-span-3 flex items-start gap-4">
              <span className="font-serif text-5xl md:text-6xl text-vermilion leading-none">
                {c.no}
              </span>
            </div>
            <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl text-ink leading-snug">
              {c.title}
            </h3>
            <p className="md:col-span-5 text-base md:text-lg text-muted2 leading-relaxed">
              {c.body}
            </p>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-14 flex flex-col gap-6">
        <a
          data-testid="about-substack-link"
          href={PROFILE.substack}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-4 self-start"
        >
          <span className="font-serif text-2xl md:text-4xl text-ink group-hover:text-vermilion transition-colors duration-300">
            Read my writing on Substack
          </span>
          <span className="inline-block text-2xl md:text-4xl text-vermilion transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5">
            ↗
          </span>
        </a>
        <div className="flex flex-wrap gap-x-10 gap-y-3 text-sm text-muted2">
          <span className="uppercase tracking-[0.15em] text-ink">Based in {PROFILE.location}</span>
          <span>Available for full-time & consulting</span>
        </div>
      </Reveal>
    </section>
  );
}
